// Development instances can use isolated chess servers alongside the usual stack.
// Production callers continue to use their public ws1/ws2/ws3 routes.
export function localChessPort(server: number) {
  const value = process.env.NEXT_PUBLIC_LOCAL_CHESS_PORT || "9090";
  const base = Number(value);
  if (!/^\d+$/.test(value) || !Number.isInteger(base) || base < 1 || base > 65533)
    throw new Error("NEXT_PUBLIC_LOCAL_CHESS_PORT must be a valid base port");
  if (![1, 2, 3].includes(server)) return undefined;
  return String(base + server - 1);
}
